// mapSlice.js
import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    points: [],
    showLiveMap: false,
    zoom: 12,
    followVehicle: false,
    center: {lat: 39.9334, lng: 32.8597}
};

const mapSlice = createSlice({
    name: 'map',
    initialState,
    reducers: {
        setPoints(state, action) {
            state.points = action.payload;
        },
        toggleLiveMap(state) {
            state.showLiveMap = !state.showLiveMap;
        },
        toggleFollowVehicle(state) {
            state.followVehicle = !state.followVehicle;
        },
        setZoom: (state, action) => {
            state.zoom = action.payload;
        },
        setMapCenter(state, action) {
            state.center = action.payload;
        },
    }
});

export const {setPoints, toggleLiveMap, setZoom, toggleFollowVehicle, setMapCenter} = mapSlice.actions;

export default mapSlice.reducer;